export default "__VITE_ASSET__B8ZAn$A5__"